import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Users, Briefcase, Award, Sparkles } from "lucide-react";
import jmbaxi from './assets/jambaxi.jpeg'
import railway from './assets/railway.jpeg'
import lulu from './assets/lulu.jpeg'
import mall from './assets/mall.jpeg'
import adani from './assets/adani.jpeg'
const Counter = ({ target, duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = target;
    const increment = end / (duration / 16);
    let current = start;

    const updateCounter = () => {
      current += increment;
      if (current < end) {
        setCount(Math.floor(current));
        requestAnimationFrame(updateCounter);
      } else {
        setCount(end);
      }
    };

    requestAnimationFrame(updateCounter);
  }, [target, duration]);

  return <>{count}</>;
};

const Client = () => {
  const stats = [
    { icon: Users, count: 120, label: "Happy Clients", delay: 0 },
    { icon: Briefcase, count: 350, label: "Total Projects", delay: 0.2 },
    { icon: Award, count: 7, label: "Years Experience", delay: 0.4 },
  ];

  const clientLogos = [
   adani, jmbaxi, lulu, mall,railway
  ];

  return (
    <>
      <style>{`
        .client-section {
          position: relative;
          padding: 80px 0;
          overflow: hidden;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #e3f2fd 100%);
        }
        
        .decorative-blur-1 {
          position: absolute;
          top: 0;
          left: 0;
          width: 400px;
          height: 400px;
          background: linear-gradient(135deg, #bbdefb 0%, #ce93d8 100%);
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.3;
          transform: translate(-50%, -50%);
        }
        
        .decorative-blur-2 {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 400px;
          height: 400px;
          background: linear-gradient(135deg, #f8bbd0 0%, #bbdefb 100%);
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.3;
          transform: translate(50%, 50%);
        }
        
        .sparkle-1 {
          position: absolute;
          top: 80px;
          right: 80px;
          animation: pulse 2s ease-in-out infinite;
        }
        
        .sparkle-2 {
          position: absolute;
          bottom: 120px;
          left: 60px;
          animation: pulse 2s ease-in-out infinite;
          animation-delay: 0.3s;
        }
        
        @keyframes pulse {
          0%, 100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.1); }
        }
        
        .stat-card {
          text-align: center;
          transition: transform 0.5s ease;
        }
        
        .stat-card:hover {
          transform: scale(1.05);
        }
        
        .icon-wrapper {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 70px;
          height: 70px;
          margin-bottom: 15px;
          background: linear-gradient(135deg, #42a5f5 0%, #ab47bc 100%);
          border-radius: 16px;
          box-shadow: 0 8px 16px rgba(66, 165, 245, 0.3);
        }
        
        .stat-number {
          font-size: 3.5rem;
          font-weight: 700;
          background: linear-gradient(135deg, #1976d2 0%, #7b1fa2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 8px;
        }
        
        .stat-label {
          color: #616161;
          font-weight: 500;
          font-size: 1rem;
        }
        
        .trusted-text {
          color: #757575;
          text-transform: uppercase;
          letter-spacing: 2px;
          font-size: 0.875rem;
          font-weight: 600;
          margin-bottom: 40px;
        }
        
        .logo-wrapper {
          width: 100px;
          height: 100px;
          background: white;
          border-radius: 16px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 15px;
          transition: all 0.3s ease;
          cursor: pointer;
        }
        
        .logo-wrapper:hover {
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          transform: translateY(-8px);
        }
        
        .logo-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transition: filter 0.3s ease;
        }
        
        .logo-wrapper:hover img {
          filter: grayscale(0%);
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .fade-in-up {
          animation: fadeInUp 0.6s ease-out both;
        }
      `}</style>

      <section className="client-section">
        {/* Decorative Elements */}
        <div className="decorative-blur-1"></div>
        <div className="decorative-blur-2"></div>
        
        {/* Floating Sparkles */}
        <div className="sparkle-1">
          <Sparkles style={{ width: 32, height: 32, color: '#90caf9', opacity: 0.5 }} />
        </div>
        <div className="sparkle-2">
          <Sparkles style={{ width: 24, height: 24, color: '#f48fb1', opacity: 0.5 }} />
        </div>

        <Container style={{ position: 'relative', zIndex: 10 }}>
          
          {/* Stats Counter Row */}
          <Row className="justify-content-center mb-5">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <Col xs={12} md={4} key={index} className="mb-4 mb-md-0">
                  <div 
                    className="stat-card fade-in-up"
                    style={{ animationDelay: `${stat.delay}s` }}
                  >
                    <div className="icon-wrapper">
                      <Icon style={{ width: 36, height: 36, color: 'white' }} />
                    </div>
                    <h2 className="stat-number">
                      <Counter target={stat.count} duration={2500} />+
                    </h2>
                    <p className="stat-label">{stat.label}</p>
                  </div>
                </Col>
              );
            })}
          </Row>

          {/* Trusted By Section */}
          <div className="text-center mt-5">
            <p className="trusted-text">Trusted by Leading Brands</p>
            <Row className="justify-content-center g-4">
              {clientLogos.map((logo, i) => (
                <Col xs={6} sm={3} md={2} key={i} className="d-flex justify-content-center">
                  <div className="logo-wrapper">
                    <img src={logo} alt={`Client ${i + 1}`} />
                  </div>
                </Col>
              ))}
            </Row>
          </div>

        </Container>
      </section>
    </>
  );
};

export default Client;